var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankratingsrtar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6311 7.70439C16.9657 7.36401 17.0838 6.86446 16.9395 6.40007C16.7948 5.93569 16.418 5.6042 15.955 5.53385L11.8388 4.90958C11.6634 4.88293 11.512 4.76817 11.4337 4.60224L9.5934 0.709185C9.38677 0.271807 8.96738 0 8.5 0C8.03295 0 7.61357 0.271807 7.40694 0.709185L5.56633 4.60224C5.48804 4.76817 5.33622 4.88293 5.1609 4.90958L1.04465 5.5342C0.582033 5.6042 0.205197 5.93569 0.0605226 6.40007C-0.0838118 6.86446 0.0343109 7.36401 0.368935 7.70439L3.34719 10.7344C3.47417 10.8637 3.53238 11.0499 3.50242 11.2318L2.79947 15.5108C2.7205 15.9915 2.90602 16.4679 3.28422 16.755C3.66207 17.0425 4.15397 17.0798 4.56825 16.852L8.24946 14.8318C8.40639 14.7458 8.59361 14.7458 8.75054 14.8318L12.4321 16.852C12.6118 16.9508 12.8065 16.9995 13.0002 16.9995C13.2518 16.9995 13.5023 16.9174 13.7161 16.755C14.0943 16.4679 14.2798 15.9915 14.2009 15.5108L13.4976 11.2322C13.4676 11.0499 13.5258 10.8641 13.6528 10.7348L16.6311 7.70439Z",
    fill: "#ABB5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankratingsrtar);
export default __webpack_public_path__ + "static/media/blankratingsrtar.532e35552962b99d7ad363b926ac81a9.svg";
export { ForwardRef as ReactComponent };